import { BYO_SET_USER_LOGIN, BYO_SET_WAITING_FOR_LOGIN } from '../constants';
export const setUserLoggedInState = (flag) => ({
    type: BYO_SET_USER_LOGIN,
    payload: flag,
});
export const setWaitingForLogin = (flag) => ({
    type: BYO_SET_WAITING_FOR_LOGIN,
    payload: flag,
});
